export default __webpack_public_path__ + "static/media/jared moskowitz.947b08bc.jpg";